import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { EventsThemeBadge } from "@faire/retailer-visitor-shared/components/Events/shared/EventsThemeBadge";
import { BadgeGuidepost } from "@faire/retailer-visitor-shared/components/ProductBadge/BadgeGuidepost";
import { isLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import * as React from "react";
import styled from "styled-components";
export var TopBadges = function(props) {
    var badgeGuidepostRef = useDoActionWhenVisible(function() {
        var _props_onTopLeftBadgeVisible;
        return (_props_onTopLeftBadgeVisible = props.onTopLeftBadgeVisible) === null || _props_onTopLeftBadgeVisible === void 0 ? void 0 : _props_onTopLeftBadgeVisible.call(props, props.tileBadge);
    });
    var productToken = props.productToken, showEventBadge = props.showEventBadge;
    var tileBadge = props.tileBadge ? /*#__PURE__*/ _jsx("div", {
        ref: badgeGuidepostRef,
        children: /*#__PURE__*/ _jsx(BadgeGuidepost, {
            badge: props.tileBadge,
            productToken: productToken
        })
    }, "tile-badge") : null;
    var favoriteBadge = isLoggedInRetailer() ? props.favoriteButton : null;
    if ((tileBadge || favoriteBadge) && !props.hideDetails) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(TopBadgesContainer, {
                    $showEventBadge: showEventBadge,
                    children: [
                        /*#__PURE__*/ _jsx(HideContainer, {
                            $showEventBadge: showEventBadge,
                            children: /*#__PURE__*/ _jsx(LeftElementContainer, {
                                children: tileBadge
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: favoriteBadge
                        })
                    ]
                }, "top-badges-container"),
                showEventBadge ? /*#__PURE__*/ _jsx(StyledEventsThemeBadge, {
                    expandable: true
                }) : null
            ]
        });
    }
    if (showEventBadge) {
        return /*#__PURE__*/ _jsx(StyledEventsThemeBadge, {
            expandable: true
        });
    }
    return null;
};
var LeftElementContainer = styled.div.withConfig({
    componentId: "sc-38053334-0"
})([
    "max-width:100%;"
]);
var TopBadgesContainer = styled(Row).attrs({
    align: "flex-start",
    justify: "space-between"
}).withConfig({
    componentId: "sc-38053334-1"
})([
    "position:absolute;top:0;width:100%;z-index:2;padding:",
    ";"
], function(param) {
    var showEventBadge = param.$showEventBadge;
    return showEventBadge ? getSpacing(14, "1x", "1x", "7x") : getSpacing(4);
});
var StyledEventsThemeBadge = styled(EventsThemeBadge).withConfig({
    componentId: "sc-38053334-2"
})([
    "position:absolute;top:",
    ";left:",
    ";z-index:2;"
], getSpacing(10), getSpacing(10));
var HideContainer = styled.div.withConfig({
    componentId: "sc-38053334-3"
})([
    "max-width:80%;min-width:0;padding:",
    ";"
], function(props) {
    return props.$showEventBadge ? "0px" : "4px";
});
